import "./index.css";
import UIComponent from "../../common/UIComponent";
export default class switchComponent extends UIComponent {
  constructor(elementId, interfaces, opt) {
    super();
    this.elementId = elementId;
    this.interfaces = interfaces;
    this.text = opt.text;
    this.id = opt.id;
    this.openCallback = opt.openCallback;
    this.closeCallback = opt.closeCallback;
    this.init();
  }
  init() {
    this.switch = document.createElement("div");
    this.switch.setAttribute('class', `vhall-player-switch ${this.id}`);
    this.switch.setAttribute("id", `${this.id}`);
    this.switch.innerHTML = `
      <input type="checkbox" id="toggle-button" name="switch">
      <label for="toggle-button" class="button-label">
        <span class="circle"></span>
        ${this.text === "" ?
        "" : `<span class="text on">${this.text}</span>
        <span class="text off">${this.text}</span>`}
      </label>`;
    this.switch.onclick = this.checkSwitch.bind(this);
    this.switch.innerHTML = this.switch.innerHTML.trim();
    this.appendChild(this.elementId, this.switch);
  }

  checkSwitch(e) {
    document.querySelector(`.${this.id} > input`).checked = !document.querySelector(`.${this.id} > input`).checked
    if (document.querySelector(`.${this.id} > input`).checked) {
      this.openCallback();
    } else {
      this.closeCallback();
    }
    e.preventDefault();
  }
}